export const ACTION = {
  REQUEST_RUN: "AI_CHAT_ASSISTANT:REQUEST_RUN",
  FAIL_RUN: "AI_CHAT_ASSISTANT:FAIL_RUN",
  FINISH_RUN: "AI_CHAT_ASSISTANT:FINISH_RUN",
  RECEIVE_DRAFT_CONFIRMATION: "AI_CHAT_ASSISTANT:RECEIVE_DRAFT_CONFIRMATION"
};

export class RequestAiAssistantRun {
  public type: string = ACTION.REQUEST_RUN;
}

export class FailAiAssistantRun {
  public type: string = ACTION.FAIL_RUN;
  constructor(public errorMessage: string) { }
}

export class FinishAiAssistantRun {
  public type: string = ACTION.FINISH_RUN;
}

export class ReceiveDraftConfirmation {
  public type: string = ACTION.RECEIVE_DRAFT_CONFIRMATION;
  constructor(public draft: any) { }
}
